import React from 'react';
import { FileTextOutlined } from '@ant-design/icons';

const LogicSummary = ({ humanString }) => {
  if (!humanString || !humanString.trim()) {
    return null;
  }
  return (
    <div
      style={{
        backgroundColor: '#f0f9ff',
        border: '1px solid #bae0ff',
        borderRadius: 4,
        padding: '12px 16px',
        marginBottom: 16
      }}>
      <div
        style={{
          color: '#0958d9',
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: 0.5,
          marginBottom: 6,
          display: 'flex',
          alignItems: 'center',
          gap: 6
        }}>
        <FileTextOutlined />
        LOGIC SUMMARY
      </div>
      <div
        style={{
          fontFamily:
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
          fontSize: 13,
          color: '#1f1f1f',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}>
        {humanString}
      </div>
    </div>
  );
};

export default LogicSummary;
